import {
  ArchiveSerialSequenceDocument,
  UnarchiveSerialSequenceDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

export const useArchiveSequences = (refetchQuery?: string) => {
  const [archiveSequenceLocal] = useMutation(ArchiveSerialSequenceDocument, {
    extractorFn: (data) => data.financeMutations.archiveFinanceSerialSequenceSalesInvoiceSequence,
    refetchQueries: refetchQuery ? [refetchQuery] : undefined,
  })
  const [unarchiveSequenceLocal] = useMutation(UnarchiveSerialSequenceDocument, {
    extractorFn: (data) => data.financeMutations.unarchiveFinanceSerialSequenceSalesInvoiceSequence,
    refetchQueries: refetchQuery ? [refetchQuery] : undefined,
  })

  const archiveSequence = async (id: string) => {
    const result = await archiveSequenceLocal({ variables: { id } })

    const handled = handleResult(result, (parsedErrors) => {
      app.setFlash({
        type: 'wrong',
        message: parsedErrors.errors ?? i18n.t('errors.generic_error'),
      })
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('finance.serial_sequences.modal.create_success'),
        time: 2000,
      })
      return { success: true, data: id }
    } else {
      return {
        errors: [],
        success: false,
      }
    }
  }

  const unarchiveSequence = async (id: string) => {
    const result = await unarchiveSequenceLocal({ variables: { id } })

    const handled = handleResult(result, (parsedErrors) => {
      app.setFlash({
        type: 'wrong',
        message: parsedErrors.errors ?? i18n.t('errors.generic_error'),
      })
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('finance.serial_sequences.modal.unarchive_success'),
        time: 2000,
      })
      return { success: true, data: id }
    } else {
      return {
        errors: [],
        success: false,
      }
    }
  }

  return {
    archiveSequence,
    unarchiveSequence,
  }
}
